const compareWidth = el => {
  if (el.querySelector('.ellipse-text') && el.querySelector('.ellipse-text').offsetWidth < el.offsetWidth) {
    const copyEl = el.parentNode
    const copySpan = el.querySelector('.ellipse-text')
    el.parentNode.removeChild(el)
    copyEl.appendChild(copySpan)
  }
}
export default {
  beforeMount: (el, binding) => {},
  mounted: el => {
    compareWidth(el)
  },
  updated: el => {
    compareWidth(el)
  }
}
